import React, { FC } from 'react'

type MenuDividerProps = {}

const MenuDivider: FC<MenuDividerProps> = () => {
  return <hr className="my-4 mx-2 sm:mx-6 border-blue-300" />
}

export default MenuDivider
